import React from "react";
import WorkInitialSection from "./Sections/WorkInitial/WorkInitial";
import Banner from "../../Components/Banner";
import Footer from "../../Components/Footer";
import { motion } from "framer-motion";
import Header from "../../Components/Header";
import GradientGlowDivider from "../../Components/GradientGlowDivider";

const WorkPage = () => {
  return (
    <motion.div
      className="flex flex-col"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
    >
      <div className="sticky md:static top-0 md:top-auto z-50 md:z-0 bg-app-background md:bg-transparent">
        <Header />
        <div className="w-[90%] mx-auto hidden md:block">
          <GradientGlowDivider />
        </div>
      </div>
      <WorkInitialSection />
      <Banner title="Shape the Future with Al" subtitle="Let's Talk!" />
      <Footer />
    </motion.div>
  );
};

export default WorkPage;
